// extracted by mini-css-extract-plugin
module.exports = {"characteristics":"Characteristics_characteristics__IcXMr","back":"Characteristics_back__24TVD"};